import axios from 'axios'
import React, { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';


export default function Footer() {

    const userId = localStorage.getItem('userid');
    const baseURL = process.env.REACT_APP_BASE_URL;
    const apiKey = process.env.REACT_APP_API_KEY;

    const [visitorData, setVisitorData] = useState(null);

    useEffect(() => {
        if (userId) {
            axios.get(`${baseURL}/get_visitor_count/?user_id=${userId}`, {
                headers: {
                    'accept': 'application/json',
                    'Authorization': apiKey
                }
            })
                .then((response) => {

                    setVisitorData(response.data);
                })
                .catch((error) => {
                    console.error('Error fetching visitor count:', error);
                });
        }
    }, [userId, baseURL, apiKey]);

    const handleScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const yOffset = -120; // Adjust offset value here too
            const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: yPosition, behavior: "smooth" });
        }
    };


    return (
        <footer className="footer-part">


            <div className="container space-container">
                <div className="row justify-content-between">

                    <div className="col-sm-12 col-xl-3">
                        <div className="footer-widget">
                            <a className="footer-logo" href="/home">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/elements/logo_dark_mode.png`} alt="logo" />
                            </a>
                            <p className="footer-desc">
                                Rashtriya e-Pustakalaya (राष्ट्रीय ई पुस्तकालय) or National Digital Library (NDL) is a
                                digital initiative by the Department of School Education and Literacy, Ministry of
                                Education, Government of India, for facilitating availability of quality digital books
                                beyond the academic curricula across geographies, languages, genres and levels, and device
                                agnostic accessibility.
                            </p>



                        </div>
                    </div>


                    <div className="col-sm-12 col-xl-8">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="footer-widget contact">
                                    <h3 className="footer-title">Information</h3>
                                    <div className="footer-links">
                                        <ul>

                                            <li><NavLink to="/contact">Contact Us</NavLink></li>
                                            <li><NavLink to="/term_condition">Terms & Conditions</NavLink></li>
                                            <li><NavLink to="/privacy">Privacy Policy</NavLink></li>
                                        </ul>
                                    </div>



                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="footer-widget contact">
                                    <h3 className="footer-title">Links</h3>
                                    <div className="footer-links">
                                        <ul>
                                            <li onClick={() => handleScroll('media')}><Link to="/home">Media</Link></li>
                                            <li onClick={() => handleScroll('blog')}><Link to="/home">Blog</Link></li>
                                            <li onClick={() => handleScroll('orientation')}><Link to="/home">Orientation</Link></li>
                                        </ul>
                                    </div>

                                </div>
                            </div>


                            <div className="col-md-5">
                                <div className="footer-widget contact">
                                    <h3 className="footer-title">contact us</h3>
                                    <ul className="footer-contact">
                                        <li>
                                            <i className="icofont-ui-email"></i>
                                            <p>
                                                <span>rashtriyaepustakalaya@gmail.com</span>
                                            </p>
                                        </li>
                                        <li>
                                            <i className="fab fa-whatsapp"></i>
                                            <p>
                                                <span>+91-9319703004</span>
                                            </p>
                                        </li>
                                        <li>
                                            <i className="icofont-location-pin"></i>
                                            <p>
                                                <strong>Rashtriya e-Pustakalaya Secretariat</strong><br></br>
                                                National Book Trust, India<br></br>
                                                3rd Floor, 5 Institutional Area,
                                                Phase-II,<br></br> Vasant Kunj, New Delhi – 110070
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>


                        </div>

                    </div>


                </div>
                <div className='col-md-12 text-center'>
                    <div className='col-md-12'>

                        <ul className="footer-social">
                            <li>
                                <NavLink className="twitter" to="https://x.com/e_pustakalaya?t=GZg3Fkx55JGt8pntIv9-Hg&s=09" target="_blank">
                                    <div className='twitter social-icons'>
                                        <svg id="twitter" xmlns="http://www.w3.org/2000/svg" width="15.044" height="14.08" viewBox="0 0 15.044 14.08">
                                            <g id="layer1" transform="translate(-281.5 -167.31)">
                                                <path id="path1009" d="M281.537,167.31l5.808,7.766L281.5,181.39h1.315l5.117-5.528,4.135,5.528h4.477l-6.135-8.2,5.44-5.877h-1.315l-4.713,5.091-3.808-5.091Zm1.934.969h2.057l9.081,12.142h-2.057Z" transform="translate(0 0)" fill="#414141" />
                                                <rect id="Rectangle_47" data-name="Rectangle 47" width="4" height="12" transform="translate(0 6.118)" fill="#414141" />
                                                <circle id="Ellipse_3" data-name="Ellipse 3" cx="2" cy="2" r="2" fill="#414141" />
                                            </g>
                                        </svg>
                                    </div>
                                </NavLink>
                            </li>

                            <li>
                                <NavLink className="insta" to="https://www.instagram.com/rashtriyaepustakalaya?igsh=MXV2OHVvdzg5Y2FvcQ==" target="_blank">
                                    <div className='social-icons insta-icon'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="17.5" viewBox="0 0 17.5 17.5">
                                            <g id="instagram" transform="translate(-1.25 -0.884)">
                                                <rect id="Rectangle_27976" data-name="Rectangle 27976" width="16" height="16" rx="5" transform="translate(2 1.634)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                <path id="Path_160" data-name="Path 160" d="M16,11.37A4,4,0,1,1,12.63,8,4,4,0,0,1,16,11.37Z" transform="translate(-2.199 -2.167)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                <line id="Line_15" data-name="Line 15" x2="0.01" transform="translate(14.115 5.518)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                            </g>
                                        </svg>
                                    </div>
                                </NavLink>
                            </li>
                            <li className=''>
                                <NavLink to="#">
                                    <div className="social-icons facebook-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M279.1 288l14.2-92.7h-88.9v-60.1c0-25.4 12.4-50.1 52.2-50.1h40.4V6.3S260.4 0 225.4 0c-73.2 0-121.1 44.4-121.1 124.7v70.6H22.9V288h81.4v224h100.2V288z" /></svg>
                                    </div>
                                </NavLink>
                            </li>
                            <li className=''>
                                <NavLink to="#">
                                    <div className="social-icons youtube-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" /></svg>
                                    </div>
                                </NavLink>
                            </li>

                        </ul>

                        <div className="newFooter--links newFooter--right">
                            <div className='counterSec'>
                                Site Visits
                                {visitorData != null && (
                                    <div className="d-flex">
                                        {visitorData.toString().split("").map((digit, index) => (
                                            <div key={index} className="count">{digit}</div>
                                        ))}
                                    </div>
                                )}

                            </div>

                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="footer-bottom">
                            <p className="footer-copytext text-center nbt-logo">
                                <span className='agency-name'>Implementing Agency</span>
                                <NavLink to="https://www.nbtindia.gov.in/" target='_blank'><img src={`${process.env.PUBLIC_URL}/assets/images/elements/nbt_light_mode.png`} className=" " alt="NBT Logo" /> </NavLink>
                            </p>
                            <p className="footer-copytext text-center">
                                <span> &copy; 2024 Rashtriya ePustakalaya. All Rights Reserved. </span> <br />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
